import React from "react";
import dayjs from "dayjs";

function MonthlyView({ calendarData, selectedDate, employees, t }) {
  const year = selectedDate.getFullYear();
  const month = selectedDate.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  // Create map of employee -> [days]
  const employeeSchedule = {};

  for (let emp of employees) {
    employeeSchedule[emp] = Array(daysInMonth).fill(false);
  }

  calendarData.forEach((entry) => {
    if (!entry.date || !entry.employee_name) return;
    const dateObj = new Date(entry.date);
    if (
      dateObj.getMonth() === month &&
      dateObj.getFullYear() === year &&
      employeeSchedule[entry.employee_name]
    ) {
      const dayIndex = dateObj.getDate() - 1;
      employeeSchedule[entry.employee_name][dayIndex] = true;
    }
  });

  return (
    <div className="monthly-view">
      <table className="monthly-table">
        <thead>
          <tr>
            <th>{t("calendar.employee")}</th>
            {[...Array(daysInMonth).keys()].map((d) => {
              const date = new Date(year, month, d + 1);
              const isWeekend = date.getDay() === 0 || date.getDay() === 6;
              return (
                <th
                  key={d}
                  style={{
                    backgroundColor: isWeekend ? "#f0f0f0" : "transparent",
                  }}
                >
                  {d + 1}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {employees.map((emp) => (
            <tr key={emp}>
              <td>{emp}</td>
              {employeeSchedule[emp].map((hasWork, i) => {
                const day = new Date(year, month, i + 1);
                const isWeekend = day.getDay() === 0 || day.getDay() === 6;
                return (
                  <td
                    key={i}
                    style={{
                      backgroundColor: hasWork ? "#9ad0ec" : "transparent",
                      opacity: isWeekend ? 0.8 : 1,
                    }}
                  ></td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default MonthlyView;
